export const menus = [
{
    label: "学年",
    key: "grade",
    options: [
        { value: "1", name: "1年生" },
        { value: "2", name: "2年生" },
        { value: "3", name: "3年生" },
        { value: "4", name: "4年生" },
        { value: "5", name: "5年生" }
    ],
}, {
    label: "学科",
    key: "department",
    options: [
        { value: "一般科目", name: "一般科目" },
        { value: "共通専門科目", name: "共通専門科目" },
        { value: "分野展開・系発展", name: "分野展開・系発展" }, 
        { value: "機械・知能系", name: "機械・知能系" },
        { value: "電気・電子系", name: "電気・電子系" }, 
        { value: "情報・ソフトウェア系", name: "情報・ソフトウェア系" },
        { value: "化学・バイオ系", name: "化学・バイオ系" }
    ],
}, {
    label: "科目の開設時期",
    key: "semester",
    options: [
        { value: "通年", name: "通年" }, 
        { value: "前期", name: "前期" }, 
        { value: "後期", name: "後期" }
    ]
}, {
    label: "科目区分",
    key: "category",
    options: [
        { value: "一般/必修", name: "一般/必修" }, 
        { value: "一般/選択", name: "一般/選択" },
        { value: "専門/必修", name: "専門/必修" }, 
        { value: "専門/選択", name: "専門/選択" }
    ]
}, {
    label: "単位種別",
    key: "credit_type",
    options: [
        { value: "履修単位", name: "履修単位" },
        { value: "学修単位", name: "学修単位" }
    ]
}, {
    label: "履修上の区分",
    key: "classification",
    options: [
        { value: "必履修", name: "必履修" },
        { value: "選択必修", name: "選択必修" }
    ]
}];